import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import validator from 'validator';
import zxcvbn from 'zxcvbn';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import {toggleDrawer} from "../../Layout/actions";
import {signupUser} from '../actions';
import {getSchoolsDropdown} from '../../Schools/actions';
import roles from '../userRoles';
import {MIN_PASSWORD_STRENGTH} from '../passwordConfig';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Link from 'react-router-dom/Link';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_signupdrawer';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

class SignupDrawer extends Component {
    state = {
        errors: {},
        activeStep: 0,
        email: '',
        password: '',
        password_confirmation: '',
        password_strength_score: null,
        password_strength_note: '',
        roles: [],
        role_other: '',
        employer: '',
        employer_other: '',
        first_name: '',
        last_name: '',
        address_line1: '',
        address_line2: '',
        address_postal_code: '',
        address_city: '',
        address_billing_type: 'personal',
        address_billing_other: false,
        address_billing_line1: '',
        address_billing_line2: '',
        address_billing_postal_code: '',
        address_billing_city: '',
    };

    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.props.getSchoolsDropdown();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errors !== this.props.errors) {
            const errors = this.props.errors;
            const errorsData = (errors && errors.hasOwnProperty('data')) ? errors.data : {};

            let step = null;

            if (errorsData.address_billing_line1 || errorsData.address_billing_line2 || errorsData.address_billing_postal_code || errorsData.address_billing_city) {
                step = 3;
            }

            if (errorsData.address_line1 || errorsData.address_line2 || errorsData.address_postal_code || errorsData.address_city) {
                step = 2;
            }

            if (errorsData.roles || errorsData.role_other || errorsData.employer || errorsData.employer_other || errorsData.first_name || errorsData.last_name) {
                step = 1;
            }

            if (errorsData.email || errorsData.password || errorsData.password_confirmation) {
                step = 0;
            }

            if (step !== null) {
                this.setState(state => ({
                    activeStep: step,
                    errors: this.props.errors,
                }));
            }
        }

        if (prevProps.auth.signupSuccess !== this.props.auth.signupSuccess) {
            if (this.props.auth.signupSuccess !== null) {
                this.setState(state => ({
                    activeStep: state.activeStep + 1,
                }));
            }
        }
    }

    handleNext = () => {
        const validated = this.validateStep(this.state.activeStep);

        if (validated) {
            if (this.state.activeStep === 4) {
                // Last step = submit the request to the server and wait for a response
                this.handleFormSubmit();
            } else {
                this.setState(state => ({
                    activeStep: state.activeStep + 1,
                }));
            }
        }
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleChange = name => e => {
        const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;

        this.setState({
            [name]: value,
        }, () => this.validateFieldsAndDisplayErrors([name]));
    };

    getSteps = () => {
        return [
            this.props.translate('auth_signup_drawer.step_identifiants'),
            this.props.translate('auth_signup_drawer.step_profil'),
            this.props.translate('auth_signup_drawer.step_home_address'),
            this.props.translate('auth_signup_drawer.step_billing_address'),
            this.props.translate('auth_signup_drawer.step_confirmation'),
        ];
    };

    getStepContent = (step) => {
        const {schoolsDropdown, schoolsDropdownLoading} = this.props.schools;
        const {errors, password_strength_score, password_strength_note} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        if (Array.isArray(schoolsDropdown) && schoolsDropdown.length === 0 || schoolsDropdownLoading) {
            return <LoadingSpinner align="center" />;
        }

        switch (step) {
            case 0:
                return (
                    <Fragment>
                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.email ? true : false}>
                            <InputLabel htmlFor="email" className="form-label"><Translate id="auth_signup_drawer.field_email" /> *</InputLabel>
                            <Input id="email" value={this.state.email} onChange={this.handleChange('email')} className="form-input" type="email" />
                            {errorsData.email && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.email)}</FormHelperText>)}
                        </FormControl>

                        <FormControl className={classnames('form-control form-control-password', 'strength-' + password_strength_score, {'has-error': errorsData.password ? true : false})} fullWidth={true} margin="normal" error={errorsData.password ? true : false}>
                            <InputLabel htmlFor="password" className="form-label"><Translate id="auth_signup_drawer.field_password" /> *</InputLabel>
                            <Input id="password" value={this.state.password} onChange={this.handleChange('password')} className="form-input" type="password" />
                            {errorsData.password && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.password)}</FormHelperText>)}
                            {(password_strength_note !== '' && this.state.password !== '') && <span className="password-strength-note">Force : {password_strength_note}</span>}
                        </FormControl>

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.password_confirmation ? true : false}>
                            <InputLabel htmlFor="password_confirmation" className="form-label"><Translate id="auth_signup_drawer.field_password_confirmation" /> *</InputLabel>
                            <Input id="password_confirmation" value={this.state.password_confirmation} onChange={this.handleChange('password_confirmation')} className="form-input" type="password" />
                            {errorsData.password_confirmation && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.password_confirmation)}</FormHelperText>)}
                        </FormControl>
                    </Fragment>
                );
            case 1:
                return (
                    <Fragment>
                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.roles ? true : false}>
                            <InputLabel htmlFor="select-multiple-checkbox"><Translate id="auth_signup_drawer.field_you_are" /> *</InputLabel>
                            <Select
                                multiple
                                id="roles"
                                value={this.state.roles}
                                onChange={this.handleChange('roles')}
                                input={<Input id="select-multiple-checkbox" />}
                                renderValue={function (selected) {
                                    let titles = [];

                                    selected.forEach(function(key) {
                                        let role = roles.find(role => role.id === key);
                                        if (role) {
                                            titles.push(role.title);
                                        }
                                    });

                                    return (
                                        <Fragment>{titles.join(', ')}</Fragment>
                                    );
                                }}
                                MenuProps={MenuProps}
                            >
                                {roles.map(role => (
                                    <MenuItem key={role.id} value={role.id}>
                                        <Checkbox checked={this.state.roles.indexOf(role.id) > -1} />
                                        <ListItemText primary={role.title} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {this.state.roles.indexOf('agep-autre') > -1 &&
                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.role_other ? true : false}>
                                <InputLabel htmlFor="role_other" className="form-label"><Translate id="auth_signup_drawer.field_other_role" /> *</InputLabel>
                                <Input id="role_other" value={this.state.role_other} onChange={this.handleChange('role_other')} className="form-input" />
                                {errorsData.role_other && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.role_other)}</FormHelperText>)}
                            </FormControl>
                        }

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.employer ? true : false}>
                            <InputLabel htmlFor="age-simple"><Translate id="auth_signup_drawer.field_employer" /> *</InputLabel>
                            <Select
                                id="employer"
                                value={this.state.employer}
                                onChange={this.handleChange('employer')}
                                inputProps={{
                                    name: 'employer',
                                }}
                            >
                                {!schoolsDropdownLoading && schoolsDropdown.map(school => (
                                    <MenuItem key={school.id} value={school.id}>{ReactHtmlParser(school.title)}</MenuItem>
                                ))}
                            </Select>
                            <div className="instruction"><Translate id="auth_signup_drawer.field_employer_instruction" /></div>
                            {errorsData.employer && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.employer)}</FormHelperText>)}
                        </FormControl>

                        {this.state.employer === 0  &&
                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.employer_other ? true : false}>
                                <InputLabel htmlFor="employer_other" className="form-label"><Translate id="auth_signup_drawer.field_employer_other" /></InputLabel>
                                <Input id="employer_other" value={this.state.employer_other} onChange={this.handleChange('employer_other')} className="form-input" />
                                {errorsData.employer_other && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.employer_other)}</FormHelperText>)}
                            </FormControl>
                        }

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.first_name ? true : false}>
                            <InputLabel htmlFor="first_name" className="form-label"><Translate id="auth_signup_drawer.field_firstname" /> *</InputLabel>
                            <Input id="first_name" value={this.state.first_name} onChange={this.handleChange('first_name')} className="form-input" />
                            {errorsData.first_name && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.first_name)}</FormHelperText>)}
                        </FormControl>

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.last_name ? true : false}>
                            <InputLabel htmlFor="last_name" className="form-label"><Translate id="auth_signup_drawer.field_lastname" /> *</InputLabel>
                            <Input id="last_name" value={this.state.last_name} onChange={this.handleChange('last_name')} className="form-input" />
                            {errorsData.last_name && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.last_name)}</FormHelperText>)}
                        </FormControl>
                    </Fragment>
                );
            case 2:
                return (
                    <Fragment>
                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line1 ? true : false}>
                            <InputLabel htmlFor="address_line1" className="form-label"><Translate id="auth_signup_drawer.field_address_line1" /> *</InputLabel>
                            <Input id="address_line1" value={this.state.address_line1} onChange={this.handleChange('address_line1')} className="form-input" />
                            {errorsData.address_line1 && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_line1)}</FormHelperText>)}
                        </FormControl>

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line2 ? true : false}>
                            <InputLabel htmlFor="address_line2" className="form-label"><Translate id="auth_signup_drawer.field_address_line2" /></InputLabel>
                            <Input id="address_line2" value={this.state.address_line2} onChange={this.handleChange('address_line2')} className="form-input" />
                            {errorsData.address_line2 && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_line2)}</FormHelperText>)}
                        </FormControl>

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_postal_code ? true : false}>
                            <InputLabel htmlFor="address_postal_code" className="form-label"><Translate id="auth_signup_drawer.field_postal_code" /> *</InputLabel>
                            <Input id="address_postal_code" value={this.state.address_postal_code} onChange={this.handleChange('address_postal_code')} className="form-input" />
                            {errorsData.address_postal_code && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_postal_code)}</FormHelperText>)}
                        </FormControl>

                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_city ? true : false}>
                            <InputLabel htmlFor="address_city" className="form-label"><Translate id="auth_signup_drawer.field_city" /> *</InputLabel>
                            <Input id="address_city" value={this.state.address_city} onChange={this.handleChange('address_city')} className="form-input" />
                            {errorsData.address_city && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_city)}</FormHelperText>)}
                        </FormControl>
                    </Fragment>
                );
            case 3:
                return (
                    <Fragment>
                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_billing_type ? true : false}>
                            <InputLabel htmlFor="select-multiple-checkbox"><Translate id="auth_signup_drawer.field_address_to_use" /></InputLabel>
                            <Select
                                id="address_billing_type"
                                value={this.state.address_billing_type}
                                onChange={this.handleChange('address_billing_type')}
                                inputProps={{
                                    name: 'address_billing_type',
                                }}
                            >
                                <MenuItem key="personal" value="personal">
                                    <Translate id="auth_signup_drawer.field_address_to_use_home" />
                                </MenuItem>
                                {this.state.employer !== 0 &&
                                    <MenuItem key="school" value="school">
                                        <Translate id="auth_signup_drawer.field_address_to_use_school" />
                                    </MenuItem>
                                }
                                <MenuItem key="other" value="other">
                                    <Translate id="auth_signup_drawer.field_address_to_use_other" />
                                </MenuItem>
                            </Select>
                        </FormControl>
                        {this.state.address_billing_type === 'other'  &&
                            <div>
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_billing_line1 ? true : false}>
                                    <InputLabel htmlFor="address_billing_line1" className="form-label"><Translate id="auth_signup_drawer.field_address_line1" /> *</InputLabel>
                                    <Input id="address_billing_line1" value={this.state.address_billing_line1} onChange={this.handleChange('address_billing_line1')} className="form-input" />
                                    {errorsData.address_billing_line1 && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_billing_line1)}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_billing_line2 ? true : false}>
                                    <InputLabel htmlFor="address_billing_line2" className="form-label"><Translate id="auth_signup_drawer.field_address_line2" /></InputLabel>
                                    <Input id="address_billing_line2" value={this.state.address_billing_line2} onChange={this.handleChange('address_billing_line2')} className="form-input" />
                                    {errorsData.address_billing_line2 && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_billing_line2)}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_billing_postal_code ? true : false}>
                                    <InputLabel htmlFor="address_billing_postal_code" className="form-label"><Translate id="auth_signup_drawer.field_postal_code" /> *</InputLabel>
                                    <Input id="address_billing_postal_code" value={this.state.address_billing_postal_code} onChange={this.handleChange('address_billing_postal_code')} className="form-input" />
                                    {errorsData.address_billing_postal_code && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_billing_postal_code)}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_billing_city ? true : false}>
                                    <InputLabel htmlFor="address_billing_city" className="form-label"><Translate id="auth_signup_drawer.field_city" /> *</InputLabel>
                                    <Input id="address_billing_city" value={this.state.address_billing_city} onChange={this.handleChange('address_billing_city')} className="form-input" />
                                    {errorsData.address_billing_city && (<FormHelperText className="form-helper">{this.props.translate('auth_signup_drawer.' + errorsData.address_billing_city)}</FormHelperText>)}
                                </FormControl>
                            </div>
                        }
                    </Fragment>
                );
                return;
            case 4:
                return (
                    <Fragment>
                        <div className="confirmation">
                            <p><Translate id="auth_signup_drawer.accept_conditions_1" /> <Link to={this.props.translate('routes.page_details_conditions')} target="_blank"><Translate id="auth_signup_drawer.terms_of_use" /></Link>.</p>
                            <p><Translate id="auth_signup_drawer.accept_conditions_2" /></p>
                        </div>
                    </Fragment>
                );
                return;
            default:
                return '';
        }
    };

    handleFormSubmit = () => {
        this.setState({errors: {}});

        const userData = {
            email: this.state.email,
            password: this.state.password,
            password_confirmation: this.state.password_confirmation,
            roles: this.state.roles,
            role_other: this.state.role_other,
            employer: this.state.employer,
            employer_other: this.state.employer_other,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            address_line1: this.state.address_line1,
            address_line2: this.state.address_line2,
            address_postal_code: this.state.address_postal_code,
            address_city: this.state.address_city,
            address_billing_type: this.state.address_billing_type,
            address_billing_other: this.state.address_billing_other,
            address_billing_line1: this.state.address_billing_line1,
            address_billing_line2: this.state.address_billing_line2,
            address_billing_postal_code: this.state.address_billing_postal_code,
            address_billing_city: this.state.address_billing_city,
            site: 1, // = AGEP
        };

        this.props.signupUser(userData);
    };

    validateFieldsAndDisplayErrors = (fields = []) => {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        let hasErrors = false;

        for (let i = 0, len = fields.length; i < len; i++) {
            let error = this.validateField(fields[i]);

            if (error !== null) {
                hasErrors = true;
            }

            errorsData[fields[i]] = error;
        }

        this.setState({
            errors: {
                ...errors,
                data: errorsData,
            }
        });

        return hasErrors;
    };

    validateField = (field) => {
        let error = null;

        switch (field) {
            case 'email':
                if (!validator.isEmail(this.state.email)) {
                    error = 'error_email_required';
                }
                break;
            case 'password':
                if (validator.isEmpty(this.state.password)) {
                    error = 'error_password_required';
                } else {
                    let note = '';
                    const strength = zxcvbn(this.state.password, [this.state.first_name, this.state.last_name, this.state.email]);

                    if (strength.score < MIN_PASSWORD_STRENGTH) {
                        error = 'error_stronger_password';
                    }

                    switch (strength.score) {
                        case 0:
                        case 1:
                            note = this.props.translate('auth_signup_drawer.error_password_strength_weak');
                            break;
                        case 2:
                            note = this.props.translate('auth_signup_drawer.error_password_strength_soso');
                            break;
                        case 3:
                            note = this.props.translate('auth_signup_drawer.error_password_strength_good');
                            break;
                        case 4:
                            note = this.props.translate('auth_signup_drawer.error_password_strength_great');
                            break;
                        default:
                            break;
                    }

                    this.setState({
                        password_strength_score: strength.score,
                        password_strength_note: note,
                    });
                }
                break;
            case 'password_confirmation':
                if (validator.isEmpty(this.state.password_confirmation)) {
                    error = 'error_confirmation_password_required';
                } else {
                    if (!validator.equals(this.state.password, this.state.password_confirmation)) {
                        error = 'error_confirmation_password_match';
                    }
                }
                break;
            case 'roles':
                if (!Array.isArray(this.state.roles) || (Array.isArray(this.state.roles) && this.state.roles.length === 0)) {
                    error = 'error_role_required';
                }
                break;
            case 'role_other':
                let hasRoleOther = false;
                if (Array.isArray(this.state.roles) && this.state.roles.length > 0) {
                    this.state.roles.forEach((role, index) => {
                        if (role === 'agep-autre') {
                            hasRoleOther = true;
                        }
                    });
                }
                if (hasRoleOther && validator.isEmpty(this.state.role_other)) {
                    error = 'error_custom_role_required';
                }
                break;
            case 'employer':
                if (!Number.isInteger(this.state.employer)) {
                    error = 'error_employer_required';
                }
                break;
            case 'first_name':
                if (validator.isEmpty(this.state.first_name)) {
                    error = 'error_first_name_required';
                } else if (this.state.first_name.length <= 2) {
                    error = 'error_first_name_too_short';
                } else {
                    if (!this.state.first_name.match(/^[A-Za-zÀ-ÿ0-9- ]*$/)) {
                        error = 'error_first_name_letters';
                    }
                }
                break;
            case 'last_name':
                if (validator.isEmpty(this.state.last_name)) {
                    error = 'error_last_name_required';
                } else if (this.state.last_name.length <= 2) {
                    error = 'error_last_name_too_short';
                } else {
                    if (!this.state.last_name.match(/^[A-Za-zÀ-ÿ0-9- ]*$/)) {
                        error = 'error_last_name_letters';
                    }
                }
                break;
            case 'address_line1':
                if (validator.isEmpty(this.state.address_line1)) {
                    error = 'error_address_line1_required';
                }
                break;
            case 'address_postal_code':
                if (validator.isEmpty(this.state.address_postal_code)) {
                    error = 'error_postal_code_required';
                } else if (this.state.address_postal_code.length > 10) {
                    error = 'error_postal_code_too_long';
                } else if (this.state.address_postal_code.length <= 2) {
                    error = 'error_postal_code_too_short';
                }
                break;
            case 'address_city':
                if (validator.isEmpty(this.state.address_city)) {
                    error = 'error_city_required';
                }
                break;
            case 'address_billing_line1':
                if (validator.isEmpty(this.state.address_billing_line1)) {
                    error = 'error_billing_address_line1_required';
                }
                break;
            case 'address_billing_postal_code':
                if (validator.isEmpty(this.state.address_billing_postal_code)) {
                    error = 'error_billing_postal_code_required';
                } else if (this.state.address_billing_postal_code.length > 10) {
                    error = 'error_billing_postal_code_too_long';
                } else if (this.state.address_billing_postal_code.length <= 2) {
                    error = 'error_billing_postal_code_too_short';
                }
                break;
            case 'address_billing_city':
                if (validator.isEmpty(this.state.address_billing_city)) {
                    error = 'error_billing_city_required';
                }
                break;
            default:
                break;
        }

        return error;
    };

    validateStep = step => {
        let isValid = true;

        switch (step) {
            case 0:
                isValid = !this.validateFieldsAndDisplayErrors(['email', 'password', 'password_confirmation']);
                break;
            case 1:
                isValid = !this.validateFieldsAndDisplayErrors(['roles', 'role_other', 'employer', 'first_name', 'last_name']);
                break;
            case 2:
                isValid = !this.validateFieldsAndDisplayErrors(['address_line1', 'address_postal_code', 'address_city']);
                break;
            case 3:
                if (this.state.address_billing_type === 'other') {
                    isValid = !this.validateFieldsAndDisplayErrors(['address_billing_line1', 'address_billing_postal_code', 'address_billing_city']);
                }
                break;
            case 4:
            case 5:
                break;
            default:
                return false;
        }

        return isValid;
    };

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    render() {
        const steps = this.getSteps();
        const {activeStep} = this.state;
        const {signupLoading} = this.props.auth;

        return (
            <Drawer anchor="right" open={this.props.layout.signupDrawerOpen} onClose={this.toggleDrawer('signup', false)} id="signup-drawer" className="header-drawer" classes={{
                paper: 'header-drawer-paper full',
            }}>
                <div className="wrapper wrapper-top">
                    <div className="inner">
                        <div className="drawer-title">
                            <span className="section"><Translate id="auth_signup_drawer.espace_personnel" /></span>
                            <h2 className="title"><Translate id="auth_signup_drawer.title_inscription" /></h2>
                            <Button size="large" className="btn-close-drawer" onClick={this.toggleDrawer('signup', false)}>
                                <CloseIcon className="m-icon"  />
                            </Button>
                            <div className="description">
                                <Translate id="auth_signup_drawer.description_message" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-bottom">
                    <div className="inner">
                        {activeStep !== steps.length ? (
                            <Fragment>
                                <div className="instructions"><Translate id="auth_signup_drawer.asterisk" /></div>
                                <form id="signup-form" ref={this.formRef} onSubmit={this.handleFormSubmit}>
                                    <Stepper activeStep={activeStep} orientation="vertical" className="stepper">
                                        {steps.map((label, index) => {
                                            return (
                                                <Step key={label}>
                                                    <StepLabel className="step-label" classes={{
                                                        iconContainer: 'iconContainer',
                                                        labelContainer: 'labelContainer',
                                                    }}>{label}</StepLabel>
                                                    <StepContent className="step-content">
                                                        <div className="contentContainer">
                                                            {this.getStepContent(index)}
                                                        </div>
                                                        <div className="actionsContainer">
                                                            {signupLoading ? (
                                                                <LoadingSpinner align="center" />
                                                            ) : (
                                                                <div>
                                                                    <Button
                                                                        className="btn-prev"
                                                                        disabled={activeStep === 0 || signupLoading}
                                                                        onClick={this.handleBack}
                                                                    >
                                                                        <Translate id="auth_signup_drawer.button_prev" />
                                                                    </Button>
                                                                    {activeStep === steps.length - 1 ? (
                                                                        <Button
                                                                            className="btn-submit"
                                                                            variant="contained"
                                                                            color="primary"
                                                                            onClick={this.handleNext}
                                                                            type="button"
                                                                            disabled={signupLoading}
                                                                        >
                                                                            <Translate id="auth_signup_drawer.button_signup" />
                                                                        </Button>
                                                                    ) : (
                                                                        <Button
                                                                            className="btn-next"
                                                                            variant="contained"
                                                                            color="primary"
                                                                            onClick={this.handleNext}
                                                                            type="button"
                                                                        >
                                                                            <Translate id="auth_signup_drawer.button_next" />
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </StepContent>
                                                </Step>
                                            );
                                        })}
                                    </Stepper>
                                </form>
                            </Fragment>
                        ) : (
                            <div className="signup-success">
                                <span className="title"><Translate id="auth_signup_drawer.last_step_title" /></span>
                                <Translate id="auth_signup_drawer.last_step_description" />
                            </div>
                        )}
                    </div>
                </div>
            </Drawer>
        );
    }
}

SignupDrawer.propTypes = {
    toggleDrawer: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    getSchoolsDropdown: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    schools: state.schools,
    auth: state.auth,
    errors: state.auth.signupErrors,
    layout: state.layout,
});

export default connect(mapStateToProps, {signupUser, getSchoolsDropdown, toggleDrawer})(withLocalize(SignupDrawer));



// WEBPACK FOOTER //
// ./src/features/Auth/components/SignupDrawer.js